import React from "react";
import logo from "../assets/logo.jpeg";

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-8 py-16">

        <div className="grid md:grid-cols-3 gap-16 mb-12">

          {/* Brand Section */}
          <div>
            {/* Logo */}
            <div className="w-20 h-20 bg-white border-2 border-white rounded-full flex items-center justify-center mb-6 overflow-hidden">
              <img
                src={logo}
                alt="Legal Lions"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Brand Name */}
            <h3 className="text-3xl font-black mb-4" style={{fontFamily: 'Georgia, serif'}}>
              LEGAL LIONS
            </h3>

            {/* Description */}
            <p className="font-sans font-light text-base text-gray-300 leading-relaxed">
              Empowering citizens through legal awareness, justice, and community service.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-black mb-8 uppercase tracking-widest" style={{fontFamily: 'Georgia, serif'}}>
              Quick Links
            </h3>

            <ul className="space-y-4 font-sans font-light text-base">
              <li>
                <a href="#home" className="text-gray-300 hover:text-white transition">
                  Home
                </a>
              </li>
              <li>
                <a href="#about" className="text-gray-300 hover:text-white transition">
                  About Us
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-300 hover:text-white transition">
                  Services
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-300 hover:text-white transition">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-black mb-8 uppercase tracking-widest" style={{fontFamily: 'Georgia, serif'}}>
              Contact
            </h3>

            <div className="space-y-6 font-sans font-light text-base">
              <div>
                <p className="text-xs uppercase tracking-widest text-gray-400 mb-2">
                  Address
                </p>
                <p className="text-gray-300">
                  Katpadi, Vellore - 632007
                </p>
              </div>

              <div>
                <p className="text-xs uppercase tracking-widest text-gray-400 mb-2">
                  Phone
                </p>
                <p className="text-gray-300">
                  +91 63799 55680
                </p>
              </div>

              <div>
                <p className="text-xs uppercase tracking-widest text-gray-400 mb-2">
                  Email
                </p>
                <p className="text-gray-300">
                  info@legallions.org
                </p>
              </div>
            </div>
          </div>

        </div>

        {/* Divider */}
        <div className="h-px bg-white/20 my-12"></div>

        {/* Copyright */}
        <div className="text-center">
          <p className="font-sans font-light text-sm text-gray-400">
            © {new Date().getFullYear()} Legal Lions People Association. All Rights Reserved.
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;